<template>
  <div class="wd-main">
    <div class="b-nav">
      <img src="../assets/imgs/spec/icon_home.png" alt="">
      <div class="location">您当前所在的位置:</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>党史学习教育</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <column-nav :fl-details="contentDetail" :now-column="nowColumn" @b-content="getChildContent" />
      <article-list :article-list="articleList" :list-title="childContent" @getPage="getNewData"/>
    </div>
  </div>
</template>

<script>
  import ColumnNav from "../components/common/ColumnNav";
  import ArticleList from "../components/common/ArticleList";
  import {peList} from "../api";

  export default {
    name: "PartyEducation",
    components: {
      ColumnNav,
      ArticleList
    },
    data() {
      return {
        contentDetail: ['党史学习教育'],
        childContent: '党史学习教育',
        nowColumn: 1,
        articleList: {},
      }
    },
    methods: {
      getNewData(num) {
        peList(num).then(res=> {
          this.articleList = res.data
          // console.log(res);
        })
      },
      getChildContent() {
        // this.childContent = this.contentDetail[data-1]
        // this.nowColumn = data
        //
        // peList(1).then(res=> {
        //   if(res.code === 1000){
        //     this.articleList = res.data
        //   }
        // })
      },
      getData() {
        peList(1).then(res=> {
          if(res.code === 1000){
            this.articleList = res.data
          }
        })
      }
    },
    mounted() {
      // this.$store.commit('changeNum',4)
    },
    created() {
      window.scroll(0,0)
      // if(this.$route.params.label){
      //   this.nowColumn = this.$route.params.label
      // }
      // this.childContent = this.contentDetail[this.nowColumn-1]
      this.getData()
    }
  }
</script>

<style scoped lang="scss">
  .wd-main {
    width: 1000px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 50px auto 0;
    .b-nav {
      width: 670px;
      height: 16px;
      display: flex;
      align-items: center;
      .location {
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        /*line-height: 16px;*/
        letter-spacing: 0;
        color: #656565;
        margin-left: 7px;
      }
      .el-breadcrumb {
        margin-left: 10px;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 16px;
        letter-spacing: 0;
        color: #656565;
        ::v-deep .is-link {
          font-weight: normal;
          color: #656565;
        }
        ::v-deep .is-link:hover {
          color: #d43e42;
          border-bottom: solid 1px #d43e42;
        }
      }
      img {
        width: 15px;
        height: 16px;
      }
    }
    .content {
      width: 1000px;
      min-height: 600px;
      margin: 30px auto 0;
      display: flex;
      justify-content: space-between;
      .spec-article {
        width: 800px;
      }
    }
  }
</style>
